<notifier-container ></notifier-container>
<!-- 
<app-sidebar >
    <app-admin-dashboard ></app-admin-dashboard> 
</app-sidebar> -->
<router-outlet></router-outlet>
 <!-- <app-dialog-delete></app-dialog-delete> -->